import type { ButtonHTMLAttributes } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
}

const styles: Record<NonNullable<ButtonProps['variant']>, React.CSSProperties> = {
  primary: { background: 'var(--ah-color-primary)', color: '#fff', border: 'none' },
  secondary: {
    background: 'transparent',
    color: 'var(--ah-color-primary)',
    border: '1px solid var(--ah-color-primary)',
  },
  danger: { background: 'var(--ah-color-danger)', color: '#fff', border: 'none' },
};

export function Button({ variant = 'primary', style, ...rest }: ButtonProps) {
  return (
    <button
      {...rest}
      style={{
        padding: 'var(--ah-space-2) var(--ah-space-3)',
        borderRadius: 'var(--ah-radius-md)',
        fontSize: 16,
        fontWeight: 600,
        cursor: rest.disabled ? 'not-allowed' : 'pointer',
        opacity: rest.disabled ? 0.6 : 1,
        ...styles[variant],
        ...style,
      }}
    />
  );
}
